/* <header-drawer> — mobile slide-in navigation with focus trap.
   Relies on trapFocus / removeTrapFocus from global.js (loaded first). */
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = this.querySelector(".header__nav-toggle");
    this.panel = this.querySelector(".header__mobile");
    this.overlay = this.querySelector("[data-header-overlay]");
    this.closeBtn = this.querySelector("[data-header-close]");

    this.toggleBtn?.addEventListener("click", () => this.open());
    this.closeBtn?.addEventListener("click", () => this.close());
    this.overlay?.addEventListener("click", () => this.close());
    this.addEventListener("keyup", (e) => e.code === "Escape" && this.close());
    this.panel?.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => this.close()));
  }

  open() {
    this.classList.add("is-open");
    this.toggleBtn?.setAttribute("aria-expanded", "true");
    if (this.overlay) this.overlay.hidden = false;
    this.panel?.removeAttribute("inert");
    document.body.classList.add("overflow-hidden");
    if (typeof trapFocus === "function") trapFocus(this.panel, this.closeBtn);
  }

  close() {
    if (!this.classList.contains("is-open")) return;
    this.classList.remove("is-open");
    this.toggleBtn?.setAttribute("aria-expanded", "false");
    this.panel?.setAttribute("inert", "");
    document.body.classList.remove("overflow-hidden");
    if (typeof removeTrapFocus === "function") removeTrapFocus(this.toggleBtn);
    // hide overlay after the fade-out
    if (this.overlay) {
      const o = this.overlay;
      setTimeout(() => {
        if (!this.classList.contains("is-open")) o.hidden = true;
      }, 450);
    }
  }
}
if (!customElements.get("header-drawer")) customElements.define("header-drawer", HeaderDrawer);
